import { ProductMenuComponent } from './../components/product-menu/product-menu.component';
import { AddAddressComponent } from './../components/add-address/add-address.component';
import { IngredientService } from './../providers/ingredient/ingredient.service';
import { PersonalizeMenuProductComponent } from './../components/personalize-menu-product/personalize-menu-product';
import { MenuModalComponent } from './../components/menu-modal/menu-modal.component';
import { mapsService } from './../providers/maps/maps.service';
import { GoogleplaceDirective } from './../directives/googleplace';
import { AuthService } from './../providers/Auth/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HostService } from '../providers/host/host.service';
import { PdvService } from '../providers/pdv/pdv.service';
import { FamilyService } from '../providers/family/family.service';
import { ProductService } from '../providers/product/product.service';
import { MenuService } from '../providers/menu/menu.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OrdersService } from '../providers/order/orders.service';
import { AddHeaderInterceptor } from '../providers/AddHeaderInterceptor/AddHeaderInterceptor';
import { WebSiteUsersService } from '../providers/webSiteUsers/webSiteUsers.service';
import { PersonalizeProductComponent } from '../components/personalize-product/personalize-product';
import { PipesModule } from '../pipes/pipes.module';
import { SharedModule } from '../components/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { TicketModalPage } from './../pages/ticket-modal/ticket-modal';
// import { AccordionModule } from 'ngx-bootstrap/accordion';
// import { TabsModule } from 'ngx-bootstrap';
import {AccordionModule} from "ngx-accordion";
import { OptionsSuppComponent } from '../components/options-supp/options-supp.component';
// import { GooglePlus } from '@ionic-native/google-plus';
import { PhoneModalPage } from '../pages/signin/phone-modal/phone-modal';
// import { Facebook } from '@ionic-native/facebook';
import { DirectivesModule } from '../directives/directives.module';


@NgModule({
  declarations: [
    MyApp,
    GoogleplaceDirective,
    PersonalizeProductComponent,
    MenuModalComponent,
    PersonalizeMenuProductComponent,
    AddAddressComponent,
    //TicketModalPage ,
    ProductMenuComponent,
    OptionsSuppComponent,
    PhoneModalPage
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    IonicModule.forRoot(MyApp),
    PipesModule,
    SharedModule,
    BrowserAnimationsModule,
    AccordionModule,
    DirectivesModule,
    // TabsModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    PersonalizeProductComponent,
    MenuModalComponent,
    PersonalizeMenuProductComponent,
    OptionsSuppComponent,
    AddAddressComponent,
    //TicketModalPage,
    PhoneModalPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    HostService,
    AuthService,
    WebSiteUsersService,
    PdvService,
    // GooglePlus,
    // Facebook,
    // AuthGuard,
    // OrderGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
    OrdersService,
    FamilyService,
    ProductService,
    MenuService,
    mapsService,
    IngredientService
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts